import React from "react";
import { Link } from "react-router-dom";

export const LoadingError = () => (
  <div className="loading">
    <p>El contenido solicitado no se encuentra disponible</p>
    <Link to="/">Ir al inicio</Link>
  </div>
);
